import React from 'react';
import SEO from '../components/seo';
import { Link } from 'gatsby';

const SctlPage = () => {
  return (
    <>
      <SEO title="特定商取引法に基づく表示" />
      <section className="sctl">
        <h2>
          <span id="">特定商取引法に基づく表示</span>
        </h2>
        <div className="rte">
          <div className="main_description">
            <dl>
              <dt>
                <h3>販売価格について</h3>
              </dt>
              <dd>
                <p>
                  販売価格は、表示された金額（表示価格/消費税込み）と致します。
                  <br />
                  配送料が別途掛かります。配送料に関して
                  <Link to="/shippingpolicy">配送ポリシー</Link>
                  をご確認ください。
                </p>
              </dd>
            </dl>
          </div>
          <div className="main_description">
            <dl>
              <dt>
                <h3>代金(対価)の支払時期と方法</h3>
              </dt>
              <dd>
                <p>
                  クレジットカード決済、Amazon
                  Pay、コンビニ支払いがご利用頂けます。
                  <br />
                  商品注文時点でお支払いが確定いたします。
                </p>
              </dd>
            </dl>
          </div>
          <div className="main_description">
            <dl>
              <dt>
                <h3>返品についての特約事項</h3>
              </dt>
              <dd>
                <p>
                  商品に欠陥がある場合を除き、返品には応じかねます。
                  <br />
                  商品に欠陥が見られた際は商品到着後7日以内にご連絡ください。
                  <br />
                  ご不明な点は、info@silencer.inc へお問い合わせください。
                </p>
              </dd>
            </dl>
          </div>
          <div className="main_description">
            <dl>
              <dt>
                <h3>商品の引き渡し時期</h3>
              </dt>
              <dd>
                <p>ご注文後、1～3営業日以内に発送します。</p>
              </dd>
            </dl>
          </div>
          <div className="main_description">
            <dl>
              <dt>
                <h3>事業者の名称および連絡先</h3>
              </dt>
              <dd>販売事業者名：株式会社サイレンサー</dd>
              <dd>住所：〒733-0003 広島県広島市西区三篠町2-5-20</dd>
              <dd>
                代表者：野村俊介
                <br />
                E-MAIL：info@silencer.inc
                <br />
                電話番号：082-230-8109
              </dd>
            </dl>
          </div>
        </div>
      </section>
    </>
  );
};

export default SctlPage;
